import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const listCustomers = async (payload = {}) => {
  try {
    const callable = functions.httpsCallable('listCustomers')
    const result = await callable(payload)
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[listCustomers] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default listCustomers
